import { maxValue, minValue } from 'react-admin';

export const maxValueCents = (max: number) =>
  maxValue(max, ({ args: { max } }: { args: { max: number } }) => ({
    message: 'ra.validation.maxValue',
    args: {
      max: max / 100,
    },
  }));

export const minValueCents = (min: number) =>
  minValue(min, ({ args: { min } }: { args: { min: number } }) => ({
    message: 'ra.validation.minValue',
    args: {
      min: min / 100,
    },
  }));
